import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import apiService from '../services/apiService';

const SecurityPage = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirmPw, setConfirmPw] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteReason, setDeleteReason] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleChangePassword = async () => {
    setError('');
    if (!currentPw || !newPw || !confirmPw) { setError('All fields are required'); return; }
    if (newPw !== confirmPw) { setError('Passwords do not match'); return; }
    if (newPw.length < 8) { setError('Password must be at least 8 characters'); return; }
    setIsLoading(true);
    try {
      const res = await apiService.changePassword(currentPw, newPw);
      if (res?.success !== false) {
        setSuccess('Password changed successfully!');
        setCurrentPw(''); setNewPw(''); setConfirmPw('');
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError(res?.error || 'Failed to change password');
      }
    } catch (e) {
      setError('Network error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    setDeleteLoading(true);
    try {
      await apiService.deleteAccount(deleteReason);
      await logout();
      navigate('/customer');
    } catch (e) {
      alert('Failed to delete account. Please try again.');
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate('/customer/profile')}>← Back</button>
        <h2 className="page-title">🔒 Security</h2>
      </div>

      <div className="security-section">
        <h3 className="section-title">Change Password</h3>
        <div className="form-group">
          <label className="form-label">Current Password</label>
          <input type="password" className="form-input" value={currentPw} onChange={e => setCurrentPw(e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">New Password</label>
          <input type="password" className="form-input" value={newPw} onChange={e => setNewPw(e.target.value)} />
        </div>
        <div className="form-group">
          <label className="form-label">Confirm New Password</label>
          <input type="password" className="form-input" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} />
        </div>
        {error && <p className="auth-error">{error}</p>}
        {success && <p className="success-msg">{success}</p>}
        <button className="btn-primary" onClick={handleChangePassword} disabled={isLoading}>
          {isLoading ? 'Changing...' : 'Change Password'}
        </button>
      </div>

      <div className="security-section danger-zone">
        <h3 className="section-title danger">Danger Zone</h3>
        <p className="danger-text">Deleting your account is permanent and cannot be undone.</p>
        <button className="btn-danger" onClick={() => setShowDeleteModal(true)}>Delete Account</button>
      </div>

      {showDeleteModal && (
        <div className="modal-overlay" onClick={() => setShowDeleteModal(false)}>
          <div className="modal-container modal-medium" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Delete Account</h3>
              <button className="modal-close" onClick={() => setShowDeleteModal(false)}>✕</button>
            </div>
            <div className="modal-body">
              <p>Are you sure? This action cannot be undone.</p>
              <div className="form-group" style={{ marginTop: 16 }}>
                <label className="form-label">Reason (optional)</label>
                <textarea className="form-input" rows={3} value={deleteReason} onChange={e => setDeleteReason(e.target.value)} placeholder="Why are you deleting your account?" />
              </div>
              <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
                <button className="btn-outline" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button className="btn-danger" onClick={handleDeleteAccount} disabled={deleteLoading}>
                  {deleteLoading ? 'Deleting...' : 'Yes, Delete Account'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SecurityPage;
